import { ReactComponent as ArrowForward } from 'assets/icons/icon-arrow-forward.svg';

export default ArrowForward;
